// extracted by mini-css-extract-plugin
export default {"wrapper":"color-picker_wrapper__GWyXx","add":"color-picker_add__0c2j5","open":"color-picker_open__zFw6U","addButton":"color-picker_addButton__UlCSo"};